module.exports = __webpack_public_path__ + "img/data-center--.b6b9e76f.png";